<template>
  <b-row
    no-gutters
    class="d-flex mb-2"
  >
    <b-col
      lg="10"
      class="d-flex"
    >
      <div class="text-primary date-label my-auto fw-bold">
        {{ dateLabel }}
      </div>
    </b-col>
    <!-- Export button -->
    <b-col
      lg="2"
      class="d-flex align-items-end mt-3 mt-lg-0"
    >
      <date-picker
        v-model="customDates"
        range
        placeholder="Choose Range Date"
        value-type="format"
        :editable="false"
        :clearable="false"
        not-after-today
      >
        <template v-slot:icon-calendar>
            &nbsp;
        </template>
        <template v-slot:icon-clear>
            &nbsp;
        </template>
        <template v-slot:input>
          <b-button
            variant="outline-primary"
            :class="['w-100',timewindowType === 'custom' ? 'active' : '']"
          >
            <i class="bx bx-calendar-alt" />
            Choose Range Date
          </b-button>
        </template>
      </date-picker>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import {
  startOfMonth, formatISO, differenceInDays, startOfYear, startOfDay, endOfDay, format,
} from 'date-fns';
import { formatDate } from '@/utils/helper';

export default {
  components: {
    DatePicker,
  },
  props: {
    defaultTimewindow: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timewindowType: this.defaultTimewindow,
      customDates: [],
      today: new Date(),

    };
  },
  computed: {
    todayString() {
      return format(new Date(), 'dd MMM yyyy');
    },

    currentMonthString() {
      return format(new Date(), 'MMM yyyy');
    },

    currentYearString() {
      return format(new Date(), 'yyyy');
    },

    dateLabel() {
      if (this.timewindowType === 'day') return this.todayString;
      if (this.timewindowType === 'month') return this.currentMonthString;
      if (this.timewindowType === 'custom') return this.customDates.map((date) => formatDate(date)).join(' to ');
      return 'Select Timerange';
    },
  },
  watch: {
    timewindowType: {
      immediate: true,
      handler(timewindow) {
        if (timewindow !== 'custom') {
          this.customDates = [];
        }

        if (timewindow === 'day') {
          this.$emit('change', {
            type: 'day',
            start: this.formatStartISO(this.today),
            end: this.formatEndISO(this.today),
          });
        }
        if (timewindow === 'month') {
          this.$emit('change', {
            type: 'month',
            start: this.formatStartISO(startOfMonth(this.today)),
            end: this.formatEndISO(this.today),
          });
        }
        if (timewindow === 'year') {
          this.$emit('change', {
            type: 'year',
            start: this.formatStartISO(startOfYear(this.today)),
            end: this.formatEndISO(this.today),
          });
        }
      },
    },

    customDates: {
      deep: true,
      handler(dates) {
        if (dates.length === 2) {
          this.timewindowType = 'custom';
          const [start, end] = dates;
          const startDate = new Date(start);
          const endDate = new Date(end);

          if (differenceInDays(endDate, startDate) > 30) {
            this.$toast.warning('Max selected range is 30 days');
            this.customDates = [];
            return;
          }

          this.$emit('change', {
            type: 'custom',
            start: this.formatStartISO(startDate),
            end: this.formatEndISO(endDate),
          });
        }
      },
    },
  },
  methods: {
    formatStartISO(date) {
      return formatISO(startOfDay(date));
    },

    formatEndISO(date) {
      return formatISO(endOfDay(date));
    },
  },
};
</script>

<style>
.w-52 {
width:20px
}
</style>
